import React from 'react';
import {
	Card, Row, Col, Button, Table, Modal, Form, DatePicker, Select,
	message, Tag, Tooltip, Typography, Pagination, Divider, Tabs, Empty,
} from 'antd';
import {
	HistoryOutlined, CheckCircleOutlined, WarningOutlined,
	CloseCircleOutlined, EyeOutlined, GlobalOutlined, CalendarOutlined,
	TeamOutlined, ApiOutlined, DownOutlined,
} from '@ant-design/icons';
import moment from 'moment';
import { connect } from 'react-redux';
import { initHandler, ajaxViewHandler, ajaxHandler, setConfig, extractResult } from '../../store/actions';
import Config from '../../Config';
import { Helmet } from 'react-helmet';
import ErrorAlertModal from '../../components/ErrorAlertModal';
import DetailAktivitasCollapse from '../../components/activitylog/DetailAktivitasCollapse';
import { groupActivityByNopolTanggal, ambilNamaPemilikGrup, ambilIpGrup } from '../../utils/activityLogGrouping';

const { Text } = Typography;
const { RangePicker } = DatePicker;
const { Option } = Select;
const { TabPane } = Tabs;

const configClass = { title: 'Log Aktivitas User' };

const config = new Config();

// Belum banyak - cuma 'login' sejauh ini (scope awal). Tambah entri baru di
// sini kalau event lain mulai dicatat - tidak perlu ubah backend.
const EVENT_LABEL = {
	login: 'Login',
	cek_nopol_eri: 'Panggil Nopol-[ERI]',
	cek_nopol_lama: 'Panggil Nopol-[Lama]',
	daftar: 'Daftar',
	tetapkan: 'Penetapan',
	hapus_penetapan: 'Batal Penetapan',
};

const AUTH_TYPE_LABEL = {
	akun_layanan: 'Akun Layanan (JWT)',
	api_key: 'API Key',
	tanpa_autentikasi: 'Tanpa Autentikasi (dibatasi IP)',
};

const STATUS_CFG = {
	success: { label: 'Sukses', bg: '#f6ffed', border: '#b7eb8f', color: '#389e0d', icon: <CheckCircleOutlined /> },
	failed:  { label: 'Gagal',  bg: '#fff1f0', border: '#ffa39e', color: '#cf1322', icon: <WarningOutlined /> },
};

const StatusTag = ({ value }) => {
	const s = STATUS_CFG[value] || { label: String(value || '—'), bg: '#f5f5f5', border: '#d9d9d9', color: '#666', icon: null };
	return (
		<Tag icon={s.icon} style={{
			borderRadius: 20, fontWeight: 700, fontSize: 12,
			background: s.bg, borderColor: s.border, color: s.color,
			padding: '2px 10px', display: 'inline-flex', alignItems: 'center', gap: 4,
		}}>
			{s.label}
		</Tag>
	);
};

class LogAktivitasAdmin extends React.Component {
	formRef = React.createRef();
	formRefEksternal = React.createRef();

	constructor(props) {
		super(props);
		this.state = {
			errMsg: '', errTitle: '',
			activeTab: 'staf',
			isMobile: window.innerWidth <= 768,
			visibleModal: false,
			dataModal: null,
			// Kartu grup (nomor_polisi+tanggal) - default TERTUTUP semua,
			// toggle per kartu lewat key-nya. Lihat diskusi rencana 2026-10-17.
			expandedGroups: {},

			// Tab Staf
			listKabupaten: [],
			loadingKabupaten: false,
			kabupaten: null,
			listUser: [],
			loadingUser: false,
			userId: null,
			filterTanggalStaf: null,
			loadingLogStaf: false,
			dataSourceStaf: [],
			paginationStaf: { current: 1, pageSize: 10, total: 0 },

			// Tab Eksternal
			listSumber: [],
			loadingSumber: false,
			sumber: null,
			filterTanggalEksternal: null,
			loadingLogEksternal: false,
			dataSourceEksternal: [],
			paginationEksternal: { current: 1, pageSize: 10, total: 0 },
		};
	}

	UNSAFE_componentWillMount() { this.props.initHandler(); }

	componentDidMount() {
		this.getKabupaten();
		this._handleResize = () => this.setState({ isMobile: window.innerWidth <= 768 });
		window.addEventListener('resize', this._handleResize);
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this._handleResize);
	}

	handleTabChange = (key) => {
		this.setState({ activeTab: key });
		if (key === 'eksternal' && this.state.listSumber.length === 0 && !this.state.loadingSumber) {
			this.getSumber();
		}
	};

	// ===================== TAB STAF =====================

	getKabupaten() {
		this.setState({ loadingKabupaten: true });
		this.props.ajaxViewHandler('get', 'master/api/kabupaten/?limit=100')
			.then((action) => {
				const { isSuccess, responseMsg } = extractResult(action);
				if (isSuccess) {
					this.setState({ listKabupaten: responseMsg.results || [] });
				} else {
					message.error({ content: 'Gagal memuat daftar kabupaten', duration: 2, key: 'toast' });
				}
				this.setState({ loadingKabupaten: false });
			})
			.catch(() => {
				message.error({ content: 'Gagal request daftar kabupaten', duration: 2, key: 'toast' });
				this.setState({ loadingKabupaten: false });
			});
	}

	handleKabupatenChange = (kabupaten) => {
		this.setState({
			kabupaten, userId: null, listUser: [],
			dataSourceStaf: [], paginationStaf: { current: 1, pageSize: 10, total: 0 },
		});
		if (!kabupaten) return;
		this.setState({ loadingUser: true });
		this.props.ajaxViewHandler('get', `activitylog/admin/users/?kabupaten=${encodeURIComponent(kabupaten)}&limit=100`)
			.then((action) => {
				const { isSuccess, responseMsg } = extractResult(action);
				if (isSuccess) {
					this.setState({ listUser: responseMsg.results || [] });
				} else {
					message.error({ content: 'Gagal memuat daftar user', duration: 2, key: 'toast' });
				}
				this.setState({ loadingUser: false });
			})
			.catch(() => {
				message.error({ content: 'Gagal request daftar user', duration: 2, key: 'toast' });
				this.setState({ loadingUser: false });
			});
	};

	handleUserChange = (userId) => {
		this.setState({ userId }, () => this.getLogStaf(1));
	};

	_buildParamsStaf(page = 1) {
		const { kabupaten, userId, paginationStaf, filterTanggalStaf } = this.state;
		const limit = paginationStaf.pageSize;
		const offset = (page - 1) * limit;
		let q = `?kabupaten=${encodeURIComponent(kabupaten)}&user_id=${encodeURIComponent(userId)}&limit=${limit}&offset=${offset}`;
		if (filterTanggalStaf && filterTanggalStaf[0]) q += `&tanggal_mulai=${filterTanggalStaf[0].format('YYYY-MM-DD')}`;
		if (filterTanggalStaf && filterTanggalStaf[1]) q += `&tanggal_akhir=${filterTanggalStaf[1].format('YYYY-MM-DD')}`;
		return q;
	}

	getLogStaf(page = 1) {
		const { kabupaten, userId } = this.state;
		if (!kabupaten || !userId) return;
		this.setState({ loadingLogStaf: true });
		this.props.ajaxViewHandler('get', 'activitylog/admin/log/' + this._buildParamsStaf(page))
			.then((action) => {
				const { isSuccess, responseMsg } = extractResult(action);
				if (isSuccess) {
					this.setState(prev => ({
						dataSourceStaf: responseMsg.results || [],
						paginationStaf: { ...prev.paginationStaf, current: page, total: responseMsg.count || 0 },
					}));
				} else {
					this.setState({ errTitle: 'Gagal memuat log', errMsg: responseMsg });
					message.error({ content: 'Gagal memuat log', duration: 2, key: 'toast' });
				}
				this.setState({ loadingLogStaf: false });
			})
			.catch(() => {
				message.error({ content: 'Gagal request data, coba lagi', duration: 2, key: 'toast' });
				this.setState({ loadingLogStaf: false });
			});
	}

	// ===================== TAB EKSTERNAL =====================

	getSumber() {
		this.setState({ loadingSumber: true });
		this.props.ajaxViewHandler('get', 'activitylog/admin/external-sources/')
			.then((action) => {
				const { isSuccess, responseMsg } = extractResult(action);
				if (isSuccess) {
					this.setState({ listSumber: responseMsg || [] });
				} else {
					message.error({ content: 'Gagal memuat daftar sumber eksternal', duration: 2, key: 'toast' });
				}
				this.setState({ loadingSumber: false });
			})
			.catch(() => {
				message.error({ content: 'Gagal request daftar sumber eksternal', duration: 2, key: 'toast' });
				this.setState({ loadingSumber: false });
			});
	}

	handleSumberChange = (sumber) => {
		this.setState({ sumber }, () => this.getLogEksternal(1));
	};

	_buildParamsEksternal(page = 1) {
		const { sumber, paginationEksternal, filterTanggalEksternal } = this.state;
		const limit = paginationEksternal.pageSize;
		const offset = (page - 1) * limit;
		let q = `?source_name=${encodeURIComponent(sumber)}&limit=${limit}&offset=${offset}`;
		if (filterTanggalEksternal && filterTanggalEksternal[0]) q += `&tanggal_mulai=${filterTanggalEksternal[0].format('YYYY-MM-DD')}`;
		if (filterTanggalEksternal && filterTanggalEksternal[1]) q += `&tanggal_akhir=${filterTanggalEksternal[1].format('YYYY-MM-DD')}`;
		return q;
	}

	getLogEksternal(page = 1) {
		const { sumber } = this.state;
		if (!sumber) return;
		this.setState({ loadingLogEksternal: true });
		this.props.ajaxViewHandler('get', 'activitylog/admin/external-log/' + this._buildParamsEksternal(page))
			.then((action) => {
				const { isSuccess, responseMsg } = extractResult(action);
				if (isSuccess) {
					this.setState(prev => ({
						dataSourceEksternal: responseMsg.results || [],
						paginationEksternal: { ...prev.paginationEksternal, current: page, total: responseMsg.count || 0 },
					}));
				} else {
					this.setState({ errTitle: 'Gagal memuat log', errMsg: responseMsg });
					message.error({ content: 'Gagal memuat log', duration: 2, key: 'toast' });
				}
				this.setState({ loadingLogEksternal: false });
			})
			.catch(() => {
				message.error({ content: 'Gagal request data, coba lagi', duration: 2, key: 'toast' });
				this.setState({ loadingLogEksternal: false });
			});
	}

	// ===================== SHARED =====================

	showDetail = (row) => this.setState({ visibleModal: true, dataModal: row });

	toggleGroup = (key) => this.setState(prev => ({
		expandedGroups: { ...prev.expandedGroups, [key]: !prev.expandedGroups[key] },
	}));

	// Timeline vertikal 1 kartu grup (nomor_polisi + tanggal) - sama pola dgn
	// LogAktivitasSaya.jsx (lihat diskusi rencana grouping 2026-10-17).
	renderTimeline(rows) {
		return (
			<div style={{ position: 'relative', paddingLeft: 22 }}>
				{rows.length > 1 && (
					<div style={{ position: 'absolute', left: 4, top: 10, bottom: 10, width: 2, background: '#e2e8f5' }} />
				)}
				{rows.map((row, idx) => {
					const s = STATUS_CFG[row.status] || { color: '#999' };
					return (
						<div key={row.id} style={{ position: 'relative', marginBottom: idx === rows.length - 1 ? 0 : 16 }}>
							<div style={{
								position: 'absolute', left: -22, top: 4, width: 10, height: 10, borderRadius: '50%',
								background: s.color, border: '2px solid #fff', boxShadow: `0 0 0 2px ${s.color}33`,
							}} />
							<div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 8, flexWrap: 'wrap' }}>
								<div>
									<Text style={{ fontWeight: 700, fontSize: 13, color: '#0f2847' }}>{EVENT_LABEL[row.event_type] || row.event_type}</Text>
									<div style={{ fontSize: 11, color: '#888', marginTop: 2 }}>{moment(row.timestamp).format('DD-MM-YYYY HH:mm:ss')}</div>
								</div>
								<div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
									<StatusTag value={row.status} />
									<Tooltip title="Lihat Detail">
										<Button size="small" shape="circle" type="primary" ghost onClick={() => this.showDetail(row)}><EyeOutlined /></Button>
									</Tooltip>
								</div>
							</div>
						</div>
					);
				})}
			</div>
		);
	}

	renderGroupCardStaf(group) {
		const nama = ambilNamaPemilikGrup(group);
		const ip = ambilIpGrup(group);
		const terbuka = !!this.state.expandedGroups[group.key];
		const metaTagStyle = { borderRadius: 20, fontSize: 11, fontWeight: 600, background: '#fff', borderColor: '#e2e8f5', color: '#667085', margin: 0 };
		return (
			<Card key={group.key} style={{ borderRadius: 14, marginBottom: 12, boxShadow: '0 2px 12px rgba(0,0,0,0.07)', border: '1px solid #f0f0f0', overflow: 'hidden' }} bodyStyle={{ padding: 0 }}>
				<div
					onClick={() => this.toggleGroup(group.key)}
					style={{ cursor: 'pointer', background: 'linear-gradient(135deg, #0f284711, #1a3a6b11)', borderBottom: terbuka ? '1px solid #d0dff5' : 'none', padding: '12px 16px' }}
				>
					<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 8 }}>
						<div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
							<Tag style={{ borderRadius: 4, fontWeight: 700, fontSize: 13, fontFamily: 'monospace', background: '#0f2847', color: '#fff', borderColor: '#0f2847', letterSpacing: 1, margin: 0 }}>
								{group.nomor_polisi}
							</Tag>
							{nama && <Text style={{ fontSize: 13, fontWeight: 600, color: '#333' }}>{nama}</Text>}
							<Tag style={metaTagStyle}>{group.rows.length} aktivitas</Tag>
						</div>
						<div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
							{ip && <Tag icon={<GlobalOutlined />} style={{ ...metaTagStyle, fontFamily: 'monospace' }}>{ip}</Tag>}
							<Text style={{ fontSize: 12, color: '#888' }}>{moment(group.tanggal).format('DD MMMM YYYY')}</Text>
							<DownOutlined style={{ fontSize: 11, color: '#888', transition: 'transform 0.2s', transform: terbuka ? 'rotate(180deg)' : 'rotate(0deg)' }} />
						</div>
					</div>
				</div>
				{terbuka && (
					<div style={{ padding: '16px 16px 14px' }}>
						{this.renderTimeline(group.rows)}
					</div>
				)}
			</Card>
		);
	}

	renderSingleCardStaf(row) {
		return (
			<Card key={row.id} style={{ borderRadius: 14, marginBottom: 12, boxShadow: '0 2px 12px rgba(0,0,0,0.07)', border: '1px solid #f0f0f0', overflow: 'hidden' }} bodyStyle={{ padding: '12px 14px' }}>
				<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
					<div>
						<div style={{ fontWeight: 700, fontSize: 14, color: '#0f2847' }}>{EVENT_LABEL[row.event_type] || row.event_type}</div>
						<div style={{ marginTop: 5 }}><StatusTag value={row.status} /></div>
					</div>
					<Tooltip title="Lihat Detail">
						<Button size="small" shape="circle" type="primary" ghost onClick={() => this.showDetail(row)}><EyeOutlined /></Button>
					</Tooltip>
				</div>
				<div style={{ display: 'flex', alignItems: 'center', gap: 6, marginTop: 8, paddingTop: 7, borderTop: '1px dashed #eee' }}>
					<Text style={{ fontSize: 11, color: '#888' }}>{moment(row.timestamp).format('DD-MM-YYYY HH:mm:ss')}</Text>
					{row.ip_address && <Text style={{ fontSize: 11, color: '#888', marginLeft: 8 }}>· {row.ip_address}</Text>}
				</div>
			</Card>
		);
	}

	renderListStaf() {
		const items = groupActivityByNopolTanggal(this.state.dataSourceStaf);
		if (items.length === 0) {
			return <div style={{ textAlign: 'center', padding: 48, color: '#aaa' }}>Tidak ada data</div>;
		}
		return items.map(item => item.type === 'group' ? this.renderGroupCardStaf(item) : this.renderSingleCardStaf(item.row));
	}

	_buildColumnsEksternal() {
		return [
			{ title: 'Waktu', dataIndex: 'timestamp', key: 'timestamp', width: 170, render: (v) => v ? <Text style={{ fontSize: 12, color: '#555' }}>{moment(v).format('DD-MM-YYYY HH:mm:ss')}</Text> : '—' },
			{ title: 'Sumber', dataIndex: 'source_name', key: 'source_name', width: 120, render: (v) => <Tag style={{ borderRadius: 4, fontWeight: 700 }}>{(v || '—').toUpperCase()}</Tag> },
			{ title: 'Identifier', dataIndex: 'identifier', key: 'identifier', width: 130, render: (v) => <Text style={{ fontSize: 12 }}>{v || '—'}</Text> },
			{ title: 'Auth Type', dataIndex: 'auth_type', key: 'auth_type', width: 190, render: (v) => <Text style={{ fontSize: 12 }}>{AUTH_TYPE_LABEL[v] || v || '—'}</Text> },
			{ title: 'Aktivitas', dataIndex: 'event_type', key: 'event_type', width: 110, render: (v) => <Text style={{ fontSize: 13 }}>{v || '—'}</Text> },
			{ title: 'Status', dataIndex: 'status', key: 'status', width: 110, align: 'center', render: (v) => <StatusTag value={v} /> },
			{ title: 'IP Address', dataIndex: 'ip_address', key: 'ip_address', width: 140, render: (v) => <Text style={{ fontFamily: 'monospace', fontSize: 12 }}>{v || '—'}</Text> },
			{ title: 'Nomor Polisi', dataIndex: 'nomor_polisi', key: 'nomor_polisi', width: 130, render: (v) => v ? <Tag style={{ borderRadius: 4, fontWeight: 700, fontSize: 12, fontFamily: 'monospace', background: '#0f2847', color: '#fff', borderColor: '#0f2847', letterSpacing: 1 }}>{v}</Tag> : <Text type="secondary">—</Text> },
			{
				title: 'Detail', key: 'detail', width: 90, align: 'center',
				render: (_, row) => <Tooltip title="Lihat Detail"><Button size="small" shape="circle" type="primary" ghost onClick={() => this.showDetail(row)}><EyeOutlined /></Button></Tooltip>,
			},
		];
	}

	renderDetailModal() {
		const { visibleModal, dataModal, isMobile } = this.state;
		if (!dataModal) return null;
		const judul = dataModal.source_name
			? `${(dataModal.source_name || '').toUpperCase()} · ${dataModal.event_type || '—'}`
			: (EVENT_LABEL[dataModal.event_type] || dataModal.event_type);
		return (
			<Modal
				visible={visibleModal}
				onCancel={() => this.setState({ visibleModal: false })}
				footer={null} title={null} closable={false}
				width={isMobile ? 'calc(100vw - 16px)' : 640}
				style={isMobile ? { top: 12, margin: '0 8px' } : { top: 40 }}
				bodyStyle={{ padding: 0 }}
				maskClosable destroyOnClose
			>
				<div style={{ background: 'linear-gradient(135deg, #0f2847 0%, #1a3a6b 100%)', borderRadius: isMobile ? 0 : '10px 10px 0 0', padding: isMobile ? '16px 18px' : '20px 24px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
					<div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
						<HistoryOutlined style={{ color: '#fff', fontSize: 20 }} />
						<div>
							<div style={{ color: '#fff', fontWeight: 700, fontSize: 15 }}>{judul}</div>
							<div style={{ color: 'rgba(255,255,255,0.65)', fontSize: 11, marginTop: 2 }}>{moment(dataModal.timestamp).format('DD-MM-YYYY HH:mm:ss')}</div>
						</div>
					</div>
					<Button type="text" icon={<CloseCircleOutlined style={{ fontSize: 18 }} />} onClick={() => this.setState({ visibleModal: false })} style={{ color: 'rgba(255,255,255,0.8)' }} />
				</div>
				<div style={{ padding: '18px 24px', maxHeight: isMobile ? '65vh' : '70vh', overflowY: 'auto' }}>
					<div style={{ display: 'flex', gap: 8, marginBottom: 14, flexWrap: 'wrap' }}>
						<StatusTag value={dataModal.status} />
						{dataModal.ip_address && <Tag icon={<GlobalOutlined />} style={{ borderRadius: 20 }}>{dataModal.ip_address}</Tag>}
						{dataModal.identifier && <Tag style={{ borderRadius: 20 }}>{dataModal.identifier}</Tag>}
					</div>
					<DetailAktivitasCollapse detail={dataModal.detail} />
				</div>
				<Divider style={{ margin: 0 }} />
				<div style={{ padding: '12px 24px', display: 'flex', justifyContent: 'flex-end', background: '#fafafa', borderRadius: isMobile ? 0 : '0 0 10px 10px' }}>
					<Button onClick={() => this.setState({ visibleModal: false })} style={{ borderRadius: 8 }}>Tutup</Button>
				</div>
			</Modal>
		);
	}

	renderTabStaf() {
		const { isMobile, listKabupaten, loadingKabupaten, kabupaten, listUser, loadingUser, userId,
			filterTanggalStaf, loadingLogStaf, paginationStaf } = this.state;
		return (
			<div>
				<div style={{ padding: '14px 20px', borderBottom: '1px solid #f0f0f0', background: '#fff' }}>
					<Form layout="vertical">
						<Row gutter={[12, 0]} align="bottom">
							<Col xs={24} sm={12} md={6}>
								<Form.Item label="Kabupaten (wajib dipilih)" style={{ marginBottom: 0 }}>
									<Select
										placeholder="Pilih kabupaten" allowClear showSearch
										optionFilterProp="children"
										loading={loadingKabupaten} value={kabupaten}
										onChange={this.handleKabupatenChange}
										style={{ width: '100%' }}
									>
										{listKabupaten.map(k => <Option key={k.id} value={k.id}>{k.name}</Option>)}
									</Select>
								</Form.Item>
							</Col>
							<Col xs={24} sm={12} md={6}>
								<Form.Item label="User (wajib dipilih)" style={{ marginBottom: 0 }}>
									<Select
										placeholder={kabupaten ? 'Pilih user' : 'Pilih kabupaten dulu'} allowClear showSearch
										optionFilterProp="children"
										loading={loadingUser} value={userId} disabled={!kabupaten}
										onChange={this.handleUserChange}
										style={{ width: '100%' }}
									>
										{listUser.map(u => <Option key={u.id} value={u.user}>{u.nama}{u.username ? ` (${u.username})` : ''}</Option>)}
									</Select>
								</Form.Item>
							</Col>
							<Col xs={24} sm={12} md={6}>
								<Form.Item label="Rentang Tanggal (default 3 hari)" style={{ marginBottom: 0 }}>
									<RangePicker
										style={{ width: '100%', borderRadius: 8 }} format="DD-MM-YYYY"
										value={filterTanggalStaf}
										onChange={(v) => this.setState({ filterTanggalStaf: v })}
										placeholder={['Dari tanggal', 'Sampai tanggal']}
									/>
								</Form.Item>
							</Col>
							<Col xs={24} sm={12} md={6}>
								<Form.Item style={{ marginBottom: 0 }}>
									<Button type="primary" disabled={!userId} loading={loadingLogStaf}
										onClick={() => this.getLogStaf(1)}
										style={{ background: 'linear-gradient(135deg, #0f2847, #1a3a6b)', border: 'none', borderRadius: 8, fontWeight: 600, width: isMobile ? '100%' : 'auto', marginTop: isMobile ? 8 : 0 }}>
										Tampilkan Log
									</Button>
								</Form.Item>
							</Col>
						</Row>
					</Form>
				</div>

				{!userId ? (
					<div style={{ padding: 48 }}><Empty description="Pilih kabupaten dan user terlebih dahulu untuk melihat log" /></div>
				) : (
					<div style={{ padding: isMobile ? 12 : 20 }}>
						{loadingLogStaf
							? <div style={{ textAlign: 'center', padding: 48, color: '#aaa' }}>Memuat data...</div>
							: this.renderListStaf()
						}
						{paginationStaf.total > 0 && (
							<div style={{ textAlign: 'center', padding: '12px 0 4px' }}>
								<Pagination
									current={paginationStaf.current} pageSize={paginationStaf.pageSize} total={paginationStaf.total}
									onChange={(page) => this.getLogStaf(page)}
									showSizeChanger={!isMobile} simple={isMobile}
									pageSizeOptions={['10', '25', '50', '100']}
									onShowSizeChange={(page, pageSize) => {
										this.setState(prev => ({ paginationStaf: { ...prev.paginationStaf, pageSize } }), () => this.getLogStaf(page));
									}}
								/>
							</div>
						)}
					</div>
				)}
			</div>
		);
	}

	renderTabEksternal() {
		const { isMobile, listSumber, loadingSumber, sumber, filterTanggalEksternal,
			loadingLogEksternal, dataSourceEksternal, paginationEksternal } = this.state;
		return (
			<div>
				<div style={{ padding: '14px 20px', borderBottom: '1px solid #f0f0f0', background: '#fff' }}>
					<Form layout="vertical">
						<Row gutter={[12, 0]} align="bottom">
							<Col xs={24} sm={12} md={8}>
								<Form.Item label="Sumber Eksternal (wajib dipilih)" style={{ marginBottom: 0 }}>
									<Select
										placeholder="Pilih sumber" allowClear showSearch
										loading={loadingSumber} value={sumber}
										onChange={this.handleSumberChange}
										style={{ width: '100%' }}
									>
										{listSumber.map(s => <Option key={s} value={s}>{s.toUpperCase()}</Option>)}
									</Select>
								</Form.Item>
							</Col>
							<Col xs={24} sm={12} md={8}>
								<Form.Item label="Rentang Tanggal (default 3 hari)" style={{ marginBottom: 0 }}>
									<RangePicker
										style={{ width: '100%', borderRadius: 8 }} format="DD-MM-YYYY"
										value={filterTanggalEksternal}
										onChange={(v) => this.setState({ filterTanggalEksternal: v })}
										placeholder={['Dari tanggal', 'Sampai tanggal']}
									/>
								</Form.Item>
							</Col>
							<Col xs={24} sm={12} md={8}>
								<Form.Item style={{ marginBottom: 0 }}>
									<Button type="primary" disabled={!sumber} loading={loadingLogEksternal}
										onClick={() => this.getLogEksternal(1)}
										style={{ background: 'linear-gradient(135deg, #0f2847, #1a3a6b)', border: 'none', borderRadius: 8, fontWeight: 600, width: isMobile ? '100%' : 'auto', marginTop: isMobile ? 8 : 0 }}>
										Tampilkan Log
									</Button>
								</Form.Item>
							</Col>
						</Row>
					</Form>
				</div>

				{!sumber ? (
					<div style={{ padding: 48 }}><Empty description="Pilih sumber eksternal terlebih dahulu untuk melihat log" /></div>
				) : (
					<div style={{ padding: isMobile ? 12 : 0 }}>
						{isMobile ? (
							<div>
								{loadingLogEksternal
									? <div style={{ textAlign: 'center', padding: 48, color: '#aaa' }}>Memuat data...</div>
									: dataSourceEksternal.length === 0
										? <div style={{ textAlign: 'center', padding: 48, color: '#aaa' }}>Tidak ada data</div>
										: dataSourceEksternal.map(row => (
											<Card key={row.id} style={{ borderRadius: 14, marginBottom: 12, border: '1px solid #f0f0f0' }} bodyStyle={{ padding: '12px 14px' }}>
												<div style={{ display: 'flex', justifyContent: 'space-between' }}>
													<div>
														<div style={{ fontWeight: 700, fontSize: 13 }}>{(row.source_name || '—').toUpperCase()} {row.identifier ? `· ${row.identifier}` : ''}</div>
														<div style={{ fontSize: 12, color: '#888' }}>{row.event_type || '—'}</div>
														<div style={{ marginTop: 5 }}><StatusTag value={row.status} /></div>
													</div>
													<Tooltip title="Lihat Detail"><Button size="small" shape="circle" type="primary" ghost onClick={() => this.showDetail(row)}><EyeOutlined /></Button></Tooltip>
												</div>
												<div style={{ display: 'flex', alignItems: 'center', gap: 6, marginTop: 8, paddingTop: 7, borderTop: '1px dashed #eee' }}>
													<CalendarOutlined style={{ color: '#aaa', fontSize: 11 }} />
													<Text style={{ fontSize: 11, color: '#888' }}>{moment(row.timestamp).format('DD-MM-YYYY HH:mm:ss')}</Text>
												</div>
											</Card>
										))
								}
								{paginationEksternal.total > 0 && (
									<div style={{ textAlign: 'center', padding: '12px 0 4px' }}>
										<Pagination current={paginationEksternal.current} pageSize={paginationEksternal.pageSize} total={paginationEksternal.total} onChange={(page) => this.getLogEksternal(page)} showSizeChanger={false} simple />
									</div>
								)}
							</div>
						) : (
							<Table
								columns={this._buildColumnsEksternal()}
								dataSource={dataSourceEksternal}
								loading={loadingLogEksternal}
								rowKey="id"
								scroll={{ x: 'max-content' }}
								size="middle"
								pagination={{
									current: paginationEksternal.current, pageSize: paginationEksternal.pageSize, total: paginationEksternal.total,
									showSizeChanger: true, pageSizeOptions: ['10', '25', '50', '100'],
									showTotal: (total, range) => `${range[0]}-${range[1]} dari ${total} data`,
									onChange: (page, pageSize) => this.setState(prev => ({ paginationEksternal: { ...prev.paginationEksternal, pageSize } }), () => this.getLogEksternal(page)),
								}}
							/>
						)}
					</div>
				)}
			</div>
		);
	}

	render() {
		const { errMsg, errTitle, activeTab } = this.state;

		return (
			<div>
				<Helmet>
					<title>{configClass.title + ' | ' + config.get_site_info().name}</title>
					<style>{`
						.actlog-admin-wrap .ant-tabs-nav { margin: 0; padding: 0 20px; background: #fff; }
					`}</style>
				</Helmet>

				<ErrorAlertModal visible={errMsg !== ''} title={errTitle} error={errMsg} onClose={() => this.setState({ errTitle: '', errMsg: '' })} />
				{this.renderDetailModal()}

				<Card className="actlog-admin-wrap" style={{ borderRadius: 14, boxShadow: '0 4px 20px rgba(0,0,0,0.07)', overflow: 'hidden' }} bodyStyle={{ padding: 0 }}>

					<div style={{ padding: '16px 20px', background: 'linear-gradient(135deg, #0f2847, #1a3a6b)', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 10 }}>
						<div>
							<div style={{ color: '#fff', fontWeight: 700, fontSize: 17 }}>
								<HistoryOutlined style={{ marginRight: 8 }} />{configClass.title}
							</div>
							<div style={{ color: 'rgba(255,255,255,0.7)', fontSize: 12, marginTop: 2 }}>
								Khusus admin/superadmin · lihat aktivitas staf atau sumber eksternal
							</div>
						</div>
					</div>

					<Tabs activeKey={activeTab} onChange={this.handleTabChange} tabBarStyle={{ padding: '0 20px', margin: 0 }}>
						<TabPane tab={<span><TeamOutlined /> Staf</span>} key="staf">
							{this.renderTabStaf()}
						</TabPane>
						<TabPane tab={<span><ApiOutlined /> Eksternal (SIGNAL/EPAHARI/dst)</span>} key="eksternal">
							{this.renderTabEksternal()}
						</TabPane>
					</Tabs>
				</Card>
			</div>
		);
	}
}

const mapStateToProps = (state) => state.configReducers;
export default connect(mapStateToProps, { initHandler, setConfig, ajaxViewHandler, ajaxHandler })(LogAktivitasAdmin);
